import { axiosGet, axiosPut } from '../plugins/axios.plugins';

const API_ENDPOINTS = {
  APP_DATA_BASEURL: `${process.env.VUE_APP_DATA_API}`,
};

export const getUserSettingsApi = async (
  username,
  customNotFoundRedirect = false
) => {
  return await axiosGet(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/users/${username}/settings`,
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

export const updateUserSettingsApi = async (username, payload) => {
  return await axiosPut(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/users/${username}/settings`,
    payload
  );
};

export const fetchUserAccessLevelApi = async (username, policyName) => {
  return await axiosGet(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/users/${username}/policies?resource=${policyName}`
  );
};
